module.exports = __webpack_public_path__ + "img/dargonFlyInSky.a39fc9f8.gif";